













































import Vue, { PropType } from 'vue';
import {Contract} from '@/types';

type Data = {
  dialog: boolean,
  error: Error | null
};

export default Vue.extend({
  props: {
    contract: {
      type: Object as PropType<Contract>,
      required: true
    }
  },
  data(): Data {
    return {
      dialog: false,
      error: null
    };
  },
  computed: {
    contract_id(): number {
      return this.$props.contract.id;
    }
  },
  methods: {
    save() {
      const { contract_id } = this;
      this.startSaving();
      this.$store.api.deactivateContract({
        contract_id
      }).then(() => {
        this.$store.change();
        this.dialog = false;
      }).catch(this.setError).then(this.stopSaving);
    }
  }
});
